import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/nl';
export const locale = {
  lang: 'nl',
  data: {
    'ODS': {
      'TITULO': 'Bedrijfsprofiel',
      'TOOLBAR': {
        'NUEVA': 'Maak het profiel voor een bedrijf',
        'EDITAR': 'U kunt de profielgegevens van dit bedrijf wijzigen',
        'CAMBIOS': '(wijzigingen worden automatisch opgeslagen)',
        'DESCARGAR': 'Bedrijfsinformatie downloaden'
      },
      'FORMULARIOS': {
        '0': 'Bedrijfsinformatie',
        '1': 'Projectleider',
        '2': 'Directeur personeelszaken',
        '3': 'IT-manager',
      },
      'BOTONES': {
        'BACK': 'Vorig',
        'NEXT': 'Volgende',
        'ACEPTAR': 'Aanvaarden'
      },
      'MODALES': {
        'EMPRESA_EXISTE': 'Er is al een geregistreerd bedrijf met de opgegeven naam, probeer het bedrijf opnieuw te maken met een andere naam',
        'ERROR_GUARDADO': 'Er is een fout opgetreden bij het aanmaken van het bedrijf, probeer het later opnieuw',
        'GUARDANDO': 'Wijzigingen opslaan',
        'GENERANDO_PDF': 'PDF-bestand genereren, wacht even'
      },
      'CAMPOS': {
        'institutoEmpresa': 'Makelaar',
        'country_application': 'Land van de makelaar',
        'nombreEmpresa': 'Bedrijf',
        'shortName': 'Korte naam bedrijf',
        'nombrePublicacion': 'Bedrijfsnaam voor publicatie',
        'account_id': 'Account ID',
        'idSalesForce': 'SalesForce-ID',
        'codigoProyecto': 'Projectcode',
        'anioFundacion': 'jaar van oprichting',
        'empleadosCompleto': 'Fulltime medewerkers',
        'empleadosParcial': 'Parttime medewerkers',
        'totalColaboradores': 'Totaal aantal medewerkers',
        'sector': 'Selecteer een sector',
        'subSector': 'Selecteer een subsector',
        'multinacional': 'multinationale',
        'name_multinational_group':'Naam van multinationale groep',
        'region': 'Selecteer een regio',
        'pais': 'Land',
        'estado': 'Staat, stad of provincie',

        'nombreResponsable': 'Naam',
        'apellidoResponsable': 'Achternaam',
        'emailResponsable': 'E-mail',
        'telResponsable': 'Telefoon',
        'extResponsable': 'Verlenging',
        'celResponsable': 'Mobiel',

        'nombreRH': 'Voor-en achternaam',
        'emailRH': 'E-mail',
        'telRH': 'Telefoon',
        'extRH': 'Verlenging',
        'celRH': 'Mobiel',

        'nombreTI': 'Voor-en achternaam',
        'emailTI': 'E-mail',
        'telTI': 'Telefoon',
        'extTI': 'Verlenging',
        'celTI': 'Mobiel',

        'PDF_sector': 'Sector',
        'PDF_subSector': 'subsector',
        'PDF_region': 'Regio',
        'PDF_fecha': 'Datum:',
        'PDF_hora': 'Uur:',
      },
      'CATALOGOS': {
        'institutoEmpresa': catalogos.institutos,
        'sector': catalogos.sectores,
        'region': catalogos.regiones,
        'multinacional': {
          '1': 'Ja',
          '2': 'Nee',
        }
      },
      'ERRORES': {
        'minlength': 'U heeft niet het minimum aantal toegestane tekens ingevoerd',
        'maxlength': 'Je hebt het maximaal toegestane aantal tekens overschreden',
        'max': 'Het ingevoerde aantal overschrijdt het toegestane maximum',
        'min': 'Het ingevoerde aantal is kleiner dan het vereiste minimum',
        'pattern': 'De ingevoerde tekst bevat tekens die in dit veld niet zijn toegestaan',
        'email': 'De ingevoerde tekst heeft niet het juiste e-mailformaat',
        'required': 'dit veld is verplicht',
        'TEXT_ESPEC_ANIOFUNDA': 'De ingevoerde datum overschrijdt het toegestane maximum',
      }
    }
  }
};
